import styled from 'styled-components'
import { linkStyles } from '../../../styles/Elements'
import { iPadDown } from '../../../styles/mediaQueries'
import globalTheme from '../../../styles/theme'
import { DolaThemeProps } from '../../../styles/types'
import { errorColor, fontFamily, fontSize } from '../../../styles/variables'
import inputTheme from '../../Input/theme'

const Modal = styled.div<DolaThemeProps>`
  color: ${({ dolaTheme }) => globalTheme[dolaTheme].text};
  font-family: ${fontFamily};

  * {
    box-sizing: border-box;
  }

  input,
  .input,
  select {
    -webkit-appearance: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    box-shadow: none;
    -webkit-box-shadow: inset 0 0 0px 1000px
      ${({ dolaTheme }) => inputTheme[dolaTheme].active.background};
  }

  input,
  select {
    font-family: inherit;
    outline: none;
  }

  select {
    font-weight: normal;
    ${fontSize};
  }

  .error-text {
    color: ${errorColor};
  }

  .centralize {
    display: flex;
    align-items: center;
    justify-content: center;

    &--vertical {
      justify-content: initial;
    }
  }

  .full-height {
    height: 100%;
  }

  .nowrap {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .spaced-out-words {
    word-spacing: 0.25vw;

    ${iPadDown} {
      word-spacing: 0.75vw;
    }
  }

  .link {
    ${linkStyles}
  }

  @-webkit-keyframes loading {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes loading {
    from {
      opacity: 0.4;
    }
    to {
      opacity: 1;
    }
  }
`

export default Modal
